import React, { useEffect, useRef, useState } from "react";
import { subscriptionType } from "../Common/Constants";

const BillingFilterModal = ({ closeFilter, filterData }) => {
  const modalRef = useRef(null);
  const [billingFilterData, setBillingFilterData] = useState({
    customerType: "",
    planType: "",
    subscriptionType: "",
  });

  const handleChange = (e) => {
    const { name, value } = e;
    setBillingFilterData((p) => ({
      ...p,
      [name]: value,
    }));
  };

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      closeFilter();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <div className="filter__dropdown" ref={modalRef}>
      <div className="filter__dropdown__body">
        <h3 className="title">Filter By</h3>
        <div className="form__Field">
          <label for="customerType" className="form__label">
            Customer Type
          </label>
          <select
            id="customerType"
            className="form__select form__select--sm"
            value={billingFilterData.customerType}
          >
            <option value="" selected="" disabled>
              -Select-
            </option>
            <option value="2">Option One</option>
            <option value="3">Option Two</option>
            <option value="4">Option Three</option>
          </select>
        </div>
        <div className="form__Field">
          <label
            for="planType"
            className="form__label"
            value={billingFilterData.planType}
          >
            Plan Type
          </label>
          <select id="planType" className="form__select form__select--sm">
            <option value="1" selected="">
              -Select-
            </option>
            <option value="2">Option One</option>
            <option value="3">Option Two</option>
            <option value="4">Option Three</option>
          </select>
        </div>
        <div className="form__Field">
          <label
            for="subscriptionType"
            className="form__label"
            value={billingFilterData.subscriptionType}
          >
            Subscription Type
          </label>
          <select
            id="subscriptionType"
            className="form__select form__select--sm"
            value={billingFilterData.subscriptionType}
            onChange={handleChange}
          >
            <option value="" selected>
              -Select-
            </option>
            {subscriptionType
              ? subscriptionType.map((type) => (
                  <option value={type.value}>{type.label}</option>
                ))
              : ""}
          </select>
        </div>
      </div>
      <div className="filter__dropdown__footer">
        <div className="btn__group">
          <button className="btn btn__white">Clear</button>
          <button className="btn btn__primary">Apply</button>
        </div>
      </div>
    </div>
  );
};

export default BillingFilterModal;
